import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../../utils/metaPixel';
interface ButtonProps {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
  href?: string;
  onClick?: () => void;
}
export function Button({
  children,
  className = '',
  fullWidth = false,
  href,
  onClick
}: ButtonProps) {
  const handleClick = () => {
    if (onClick) onClick();
    if (href) {
      trackAddToCart();
      window.open(href, '_blank', 'noopener,noreferrer');
    }
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`
        bg-gold hover:bg-gold-light text-navy-dark font-bold py-4 px-8 
        rounded-sm shadow-gold hover:shadow-gold-lg transition-all duration-300
        uppercase tracking-wider text-sm md:text-base cursor-pointer
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} data-id="element-12">
      {children}
    </motion.button>;
}